<template>
    <div v-if="loaded">
        <nav class="mx-4 border-b border-gray-dark">
            <h2 class="font-bold text-xl px-4 py-4">Billing</h2>
        </nav>
        <div
            v-if="subscription.plan && subscription.plan.id === 'complimentary'"
        >
            <div
                class="m-4 bg-primary-lighter py-4 px-8 rounded md:flex md:items-center md:justify-between"
            >
                <div class="py-2 px-4 rounded-md text-primary">
                    <p>
                        Congratulations! You're enjoying our complimentary
                        membership and will get access to all the current and
                        future features for <strong>free forever</strong>.
                    </p>
                </div>
            </div>
        </div>
        <div
            v-else-if="subscription.plan && subscription.plan.id === 'lifetime'"
        >
            <div
                class="m-4 bg-primary-lighter py-4 px-8 rounded md:flex md:items-center md:justify-between"
            >
                <div class="py-2 px-4 rounded-md text-primary">
                    <p>
                        Congratulations! You're enjoying our lifetime
                        membership.
                    </p>
                </div>
            </div>
        </div>
        <div
            v-else-if="
                subscription.plan && subscription.plan.id === 'lifetime-lite'
            "
        >
            <div
                class="m-4 bg-primary-lighter py-4 px-8 rounded md:flex md:items-center md:justify-between"
            >
                <div class="py-2 px-4 rounded-md text-primary">
                    <p>
                        Congratulations! You're enjoying our limited lifetime
                        membership.
                    </p>
                </div>
            </div>

            <p class="mt-10 text-center">
                Upgrade to a regular plan to add multiple inbox support to your
                account.
            </p>
            <plan-picker></plan-picker>
        </div>
        <div
            v-else-if="
                subscription.status === null ||
                subscription.status === 'trialing'
            "
        >
            <div v-if="subscription.status === 'trialing'">
                <div
                    class="mx-4 mt-4 bg-primary-lighter py-4 px-8 rounded md:flex md:items-center md:justify-between"
                >
                    <div class="py-2 px-4 rounded-md text-primary">
                        <p>
                            Your free trial ends on
                            <strong>{{ subscription.trial_ends_on }}</strong
                            >. If you enjoy newly-found sanity in your inbox,
                            consider upgrading to a paid plan to enjoy
                            uninterrupted sanity.
                        </p>
                    </div>
                </div>
            </div>
            <subscription-lifetime-unlock
                v-if="canUnlockLifetimeMembership"
            ></subscription-lifetime-unlock>
            <!-- when there's no subscription -->
            <plan-picker :endpoint="endpoint"></plan-picker>
        </div>
        <div v-else>
            <subscription-plan
                :status="subscription.status"
                :plan="subscription.plan"
                :endpoint="endpoint"
                picker="plan-picker"
                v-if="subscription.plan"
            >
            </subscription-plan>
            <subscription-payment-method
                :billing-portal-url="subscription.billing_portal_url"
                :card="subscription.card"
                :endpoint="endpoint"
                v-if="subscription.card"
            >
            </subscription-payment-method>
        </div>
        <subscription-payment-history
            :invoices="subscription.invoices"
            v-if="subscription.invoices && subscription.invoices.length > 0"
        >
        </subscription-payment-history>
    </div>
    <div v-else>
        <loading />
    </div>
</template>

<script>
export default {
    data() {
        return {
            loaded: false,
            canUnlockLifetimeMembership:
                window.User.can_unlock_lifetime_membership,
            endpoint: `/api/subscription`,
            subscription: {},
        };
    },
    mounted() {
        axios
            .get(`${this.endpoint}?full`)
            .then((response) => {
                this.subscription = response.data.data;
                this.loaded = true;
            })
            .catch((err) => {
                console.error(err);
            });
    },
};
</script>
